// Add your custom JS here.
// Note: Navbar height is now handled by js/sticky-nav.js which is enqueued separately.

// Make CTA image blocks fully clickable
document.addEventListener('DOMContentLoaded', function() {
	const ctaBlocks = document.querySelectorAll('.wp-block-cover.cta-image');
	
	ctaBlocks.forEach(block => {
		const link = block.querySelector('a');
		if (link) {
			block.addEventListener('click', function(e) {
				// Don't double-trigger if clicking on the link itself
				if (e.target !== link && !link.contains(e.target)) {
					link.click();
				}
			});
		}
	});
});
